


import { Component, Vue, Watch } from "vue-property-decorator";

import { ApiKeys, Customers } from "App";
import { $t, EventBus } from "App/IOC";
import { Activated, GroupUser, Identifiable, Named } from "App/Contracts";

import DatePicker from "Web/Components/Common/Input/DatePicker.vue";
import PopupWindow from "Web/Components/Popup/Window.vue";

import TokenBlock from "./TokenBlock.vue";

/* GENERER UNE CLEF — deux temps dans la meme fenetre.

   1. Pour qui ( un utilisateur du logiciel, cherche par nom ou e-mail ), un
      libelle, une date d'expiration facultative ( sans date : sans limite ).
   2. Le jeton, avec « Copier » et les en-tetes. Il reste relisable ensuite par
      « Afficher la clé » — ici comme chez le client. */
@Component({
    components: {
        DatePicker,
        PopupWindow,
        TokenBlock
    }
})
export default class ApiKeyGenerateForm extends Vue {
    private keyword: string = "";
    private keywordTimer: number = 0;
    private searching: boolean = false;
    private candidates: GroupUser[] = [];

    /* Initialise ( pas seulement declare ) pour que Vue l'observe. */
    private user: GroupUser | null = null;

    private name: string = "";
    private expiresAt: string = "";

    private saving: boolean = false;
    private token: string = "";

    private action: Identifiable & Named & Activated = {
        Id: "generate",
        Name: $t( "API_KEYS_confirmGenerate" ),
        Active: false
    };

    /* La date du jour, au format du champ : une clef valable jusqu'a la fin
       d'aujourd'hui est la plus courte que l'API accepte. */
    private get today(): string {
        const now = new Date();
        const pad = ( value: number ): string => String( value ).padStart( 2, "0" );

        return `${now.getFullYear()}-${pad( now.getMonth() + 1 )}-${pad( now.getDate() )}`;
    }

    private get canGenerate(): boolean {
        return this.token === "" && !this.saving && this.user !== null && this.name.trim() !== "";
    }

    private refreshAction(): void {
        this.action.Active = this.token !== "" || this.canGenerate;
    }

    @Watch( "keyword" )
    private onKeyword(): void {
        window.clearTimeout( this.keywordTimer );

        if( this.keyword.trim().length < 2 ) {
            this.candidates = [];
            return;
        }

        this.keywordTimer = window.setTimeout( () => this.search(), 300 );
    }

    private async search(): Promise<void> {
        const keyword = this.keyword.trim();

        this.searching = true;

        const [ result, error ] = await Customers.ListUsers( 1, 8, "", keyword );

        /* Une frappe plus recente a deja relance la recherche. */
        if( keyword !== this.keyword.trim() )
            return;

        this.searching = false;

        if( error !== undefined ) {
            EventBus.Publish( "Error", error );
            return;
        }

        this.candidates = result.Users;
    }

    private pick( user: GroupUser ): void {
        this.user = user;
        this.keyword = "";
        this.candidates = [];
        this.refreshAction();
    }

    private unpick(): void {
        this.user = null;
        this.refreshAction();
    }

    private describe( user: GroupUser ): string {
        return [ user.Name, user.Group ].filter( part => part !== "" ).join( " — " );
    }

    private async execute(): Promise<void> {
        /* Second temps : l'action ne fait plus que fermer. */
        if( this.token !== "" ) {
            this.$emit( "Close" );
            return;
        }

        if( !this.canGenerate || this.user === null )
            return;

        this.saving = true;
        this.refreshAction();

        const [ result, error ] = await ApiKeys.Generate( {
            UserId: this.user.Id,
            Name: this.name.trim(),
            ExpiresAt: this.expiresAt
        } );

        this.saving = false;

        if( error !== undefined || result === undefined ) {
            this.refreshAction();
            EventBus.Publish( "Error", error );
            return;
        }

        this.token = result.Token;
        this.action.Name = $t( "API_KEYS_close" );
        this.refreshAction();

        this.$emit( "Create" );
    }
}
